import React from "react";
import { useNavigate } from "react-router";
import "./ListCustomer.css";
import { fetchCustomers } from "../../Redux/api";
import ViewCustomer from "./ViewCustomer";


// const ListCustomers = () => {
//   return (
//     <div className="container bg-white p-4 rounded shadow-sm mt-4">
//       {/* Top Controls */}
//       <div className="d-flex justify-content-between mb-3 align-items-center flex-wrap gap-3">
//         <div className="d-flex align-items-center gap-4 flex-wrap">
//           <label className="me-2 mb-0">Show</label>
//           <select className="form-select form-select-sm w-auto">
//             <option>10</option>
//             <option>25</option>
//             <option>50</option>
//           </select>
//           <button className="btn btn-primary btn-sm">+ Create Invoice</button>
//         </div>
//         <div className="d-flex align-items-center gap-2 flex-wrap">
//           <input type="text" className="form-control form-control-sm" placeholder="Search Invoice" />
//           <select className="form-select form-select-sm w-auto">
//             <option>Invoice Status</option>
//           </select>
//         </div>
//       </div>

//       {/* Table */}
//       <table className="table table-hover align-middle">
//         <thead className="table-light">
//           <tr>
//             <th><input type="checkbox" /></th>
//             <th>#</th>
//             <th>Status</th>
//             <th>Client</th>
//             <th>Total</th>
//             <th>Issued Date</th>
//             <th>Balance</th>
//             <th>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {/* Sample Row */}
//           <tr>
//             <td><input type="checkbox" /></td>
//             <td><a href="#">#5089</a></td>
//             <td><span className="text-muted">&#9993;</span></td>
//             <td>
//               <div className="d-flex align-items-center">
//                 <div className="bg-secondary text-white rounded-circle d-flex justify-content-center align-items-center me-2" style={{ width: '35px', height: '35px' }}>
//                   JK
//                 </div>
//                 <div>
//                   <div className="fw-semibold">Jamal Kerrod</div>
//                   <small className="text-muted">Software Development</small>
//                 </div>
//               </div>
//             </td>
//             <td>$3077</td>
//             <td>09 May 2020</td>
//             <td><span className="badge bg-success">Paid</span></td>
//             <td>
//               <button className="btn btn-sm text-secondary"><i className="bi bi-eye"></i></button>
//               <button className="btn btn-sm text-secondary"><i className="bi bi-trash"></i></button>
//               <button className="btn btn-sm text-secondary"><i className="bi bi-three-dots"></i></button>
//             </td>
//           </tr>
//         </tbody>
//       </table>

//       {/* Pagination */}
//       <div className="d-flex justify-content-between align-items-center">
//         <div>Showing 1 to 10 of 50 entries</div>
//         <nav>
//           <ul className="pagination pagination-sm mb-0">
//             <li className="page-item disabled"><a className="page-link" href="#">‹</a></li>
//             <li className="page-item active"><a className="page-link" href="#">1</a></li>
//             <li className="page-item"><a className="page-link" href="#">2</a></li>
//             <li className="page-item"><a className="page-link" href="#">3</a></li>
//             <li className="page-item"><a className="page-link" href="#">4</a></li>
//             <li className="page-item"><a className="page-link" href="#">5</a></li>
//             <li className="page-item"><a className="page-link" href="#">›</a></li>
//           </ul>
//         </nav>
//       </div>
//     </div>
//   );
// };

const ListCustomers = () => {
  const navigate = useNavigate();
  const [customers, setCustomers] = React.useState([]);
  const [search, setSearch] = React.useState("");
  const [showModal, setShowModal] = React.useState(false);
  const [selectedCustomer, setSelectedCustomer] = React.useState(null);
  // Handler to open modal with selected customer
  const handleViewClick = (customer) => {
    setSelectedCustomer(customer);
    setShowModal(true);
  };

  // Handler to close modal
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedCustomer(null);
  };

  React.useEffect(() => {
    async function loadCustomers() {
      try {
        // Only call API if search is empty or has more than 2 characters
        if (!search || search.length > 2) {
          const data = await fetchCustomers(search);
          setCustomers(data);
        } else {
          fetchCustomers(null)
          setCustomers([]);
        }
      } catch (err) {
        // handle error
        setCustomers([]);
      }
    }
    loadCustomers();
  }, [search]);

  const handleAddClick = () => {
    navigate("/invoice");
  };

  // Dropdown state for actions menu
  const [openMenuIdx, setOpenMenuIdx] = React.useState(null);
  const dropdownRef = React.useRef(null);

  const handleMenuToggle = (idx) => {
    setOpenMenuIdx(openMenuIdx === idx ? null : idx);
  };
  const handleMenuClose = () => setOpenMenuIdx(null);

  // Close dropdown on outside click
  React.useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenMenuIdx(null);
      }
    }
    if (openMenuIdx !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openMenuIdx]);

  return (
    <div className="container bg-white p-4 rounded rounded shadow mt-4">
      <div className="d-flex p-2 justify-content-start">
        <h1>List Customers</h1>
      </div>

      <div className="row align-items-center p-2">
        <div className="col d-flex align-items-center">
          <label className="me-4 mb-0 mr-2">Show</label>
          <select className="form-control form-control-sm w-auto">
            <option>10</option>
            <option>20</option>
            <option>50</option>
          </select>
        </div>
        <div className="col-auto ms-auto">
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Search"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>
        <div>
          <button
            id="btnAddCustomer"
            type="button"
            className="btn btn-primary btn-sm px-5"
            onClick={handleAddClick}
          >
            Add
          </button>
        </div>
      </div>

      <div style={{ maxHeight: "680px", overflowY: "auto" }}>
        <table className="table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Customer</th>
              <th scope="col">Pest Service</th>
              <th scope="col">Date</th>
              <th scope="col">Village</th>
              <th scope="col">City</th>
              <th scope="col">State</th>
              <th scope="col">Amount</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(customers) && customers.length > 0 ? (
              customers.map((customer, idx) => (
                <tr key={customer.id}>
                  <th scope="row">{customer.invoiceId}</th>
                  <td>{customer.customerName}</td>
                  <td>{customer.pestService || '-'} </td>
                  <td>{customer.dateOfService ? new Date(customer.dateOfService).toLocaleDateString() : '-'} </td>
                  <td>{customer.village || '-'} </td>
                  <td>{customer.city}</td>
                  <td>{customer.state}</td>
                  <td>{customer.amount}</td>
                  <td style={{ position: 'relative' }}>
                    <button className="btn btn-sm text-secondary me-1 mr-2"><i className="bi bi-trash"></i></button>
                    <button className="btn btn-sm text-secondary me-1 mr-2" onClick={() => handleViewClick(customer)}><i className="bi bi-eye"></i></button>
                    <button
                      className="btn btn-sm text-secondary"
                      style={{ fontWeight: 'bold', verticalAlign: 'middle' }}
                      onClick={() => handleMenuToggle(customer.id)}
                      aria-label="More actions"
                    >
                      <i className="bi bi-three-dots-vertical"></i>
                    </button>
                    {openMenuIdx === customer.id && (
                      <div
                        ref={dropdownRef}
                        className="dropdown-menu show"
                        style={{ position: 'absolute', right: 0, top: '100%', minWidth: '140px', zIndex: 10, display: 'block', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}
                      >
                        <button className="dropdown-item" onClick={handleMenuClose}>Download</button>
                        <button className="dropdown-item" onClick={handleMenuClose}>Edit</button>
                        <button className="dropdown-item" onClick={handleMenuClose}>Duplicate</button>
                      </div>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center">No customers found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <nav aria-label="...">
        <ul className="pagination">
          <li className="page-item disabled">
            <span className="page-link">Previous</span>
          </li>
          <li className="page-item">
            <a className="page-link" href="#">
              1
            </a>
          </li>
          <li className="page-item active">
            <span className="page-link">
              2<span className="sr-only">(current)</span>
            </span>
          </li>
          <li className="page-item">
            <a className="page-link" href="#">
              3
            </a>
          </li>
          <li className="page-item">
            <a className="page-link" href="#">
              Next
            </a>
          </li>
        </ul>
      </nav>
      {/* Bootstrap Modal for ViewCustomer */}
      {showModal && (
        <ViewCustomer customer={selectedCustomer} onClose={handleCloseModal} />
      )}
    </div>
  );
};

export default ListCustomers;
